<template>
  <SearchBar
    :keyword="keyword"
    :search-result="searchResult"
    :placeholder="placeholder"
    @search="search"
    @inputKeyword="$emit('inputKeyword', $event)"
    @pagination="$emit('pagination', $event)"
  >
    <slot />
    <template v-slot:searchArea>
      <slot name="searchArea" />
      <RequestStatusFilter
        :value="requestStatus"
        class="pr-2"
        style="max-width:200px;"
        @input="$emit('inputRequestStatus', $event)"
      />
    </template>
  </SearchBar>
</template>

<script>
import SearchBar from './SearchBar'
import RequestStatusFilter from '@/components/Shared/Search/RequestStatusFilter'

export default {
  name: 'SearchBarRequest',
  components: { SearchBar, RequestStatusFilter },
  props: {
    searchResult: {
      type: Object,
      default: () => {},
    },
    placeholder: {
      type: String,
      default: '検索',
    },
    keyword: {
      type: String,
      default: '',
    },
    requestStatus: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showNotApprovedRecord: false,
    }
  },
  methods: {
    search(keyword) {
      this.$emit('search', {
        keyword: keyword,
        requestStatus: this.requestStatus,
      })
    },
  },
}
</script>
